<template>
  <div class="border-b" v-if="property_tenure_options">
    <div class="max-w-6xl py-3 mx-auto">
      <div class="justify-between hidden w-full mx-auto md:flex md:space-x-2">
        <!-- Search Input -->
        <InputField v-model:keyword="keyword" />

        <!-- Dropdowns -->
        <div v-if="property_tenure_options" class="w-auto">
          <FilterDropdown
            v-if="property_tenure_options"
            :items="property_tenure_options"
            label="Buy"
            unique-identifier="buy"
            @item-selected="handleMenuItemSelected"
          />
        </div>
        <div v-if="property_types" class="w-auto">
          <FilterDropdown
            v-if="property_types"
            :items="property_types"
            label="Property Type"
            unique-identifier="property-types"
            @item-selected="handleMenuItemSelected"
          />
        </div>

        <!-- Beds & Baths dropdown -->
        <div class="w-auto">
          <DropdownBedBath
            radius="lg"
            height="[48px]"
            button-label="Beds & Baths"
            @bath-bed-selected="handleBathBedSelected"
          />
        </div>

        <!-- Price dropdown -->
        <div class="w-auto">
          <PriceDropdown
            radius="lg"
            height="[48px]"
            @price-range-selected="handlePriceRangeSelected"
            button-label="Price"
          />
        </div>

        <!-- More Filters Button -->
        <div class="w-auto">
          <MoreFiltersButton @click="toggleModal" />
        </div>

        <FindButton :loading="loading" @click="filterProperties" />
      </div>
    </div>

    <!-- Modal -->
    <SearchFilterModal
      :show-modal="showModal"
      @close-modal="closeViewModal"
      @more-property-filters="handleMorePropertyFilters"
    />
  </div>
</template>

<script>
import InputField from "./InputField.vue";
import FilterDropdown from "./FilterDropdown.vue";
import DropdownBedBath from "@/components/form-components/BedBathDropdown.vue";
import PriceDropdown from "@/components/form-components/PriceDropdown.vue";
import MoreFiltersButton from "./MoreFiltersButton.vue";
import FindButton from "./FindButton.vue";
import SearchFilterModal from "@/features/properties/SearchFilterModal.vue";
import { ref, watch } from "vue";

export default {
  name: "DesktopView",
  components: {
    FilterDropdown,
    DropdownBedBath,
    PriceDropdown,
    MoreFiltersButton,
    FindButton,
    InputField,
    SearchFilterModal,
  },
  props: {
    property_tenure_options: Array,
    property_types: Array,
    isDropdownOpen: Boolean,
    showModal: Boolean,
  },
  emits: ["filter-parameters"],
  setup(props, { emit }) {
    const localShowModal = ref(props.showModal);
    const keyword = ref("");
    const propertyTypeId = ref(null);
    const tenureId = ref(null);
    const minPrice = ref(null);
    const maxPrice = ref(null);
    const numBed = ref(null);
    const numBath = ref(null);
    const loading = ref(false);

    const handleMenuItemSelected = (payload) => {
      if (payload.dropdownIdentifier === "property-types") {
        propertyTypeId.value = payload.itemId;
      } else if (payload.dropdownIdentifier === "buy") {
        tenureId.value = payload.itemId;
      }
    };

    const handlePriceRangeSelected = (payload) => {
      minPrice.value = payload.minPrice;
      maxPrice.value = payload.maxPrice;
    };

    const handleBathBedSelected = (payload) => {
      numBed.value = payload.Bedroom.value;
      numBath.value = payload.Bathroom.value;
    };

    const filterProperties = async () => {
      loading.value = true;
      try {
        await new Promise((resolve) => {
          setTimeout(() => {
            emit("filter-parameters", {
              keyword: keyword.value,
              min_price: minPrice.value,
              max_price: maxPrice.value,
              number_of_beds: numBed.value,
              number_of_baths: numBath.value,
              property_type_id: propertyTypeId.value,
              property_tenure_option_id: tenureId.value,
            });
            resolve();
          }, 1000);
        });
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    };

    const handleMorePropertyFilters = (filters) => {
      emit("more-property-filters", filters);
    };

    const toggleModal = () => {
      localShowModal.value = !localShowModal.value;
      emit("toggle-modal");
    };

    const closeViewModal = () => {
      localShowModal.value = false;
      emit("close-modal");
    };

    watch(
      () => props.showModal,
      (newVal) => {
        localShowModal.value = newVal;
      }
    );

    return {
      loading,
      keyword,
      propertyTypeId,
      tenureId,
      minPrice,
      maxPrice,
      numBed,
      numBath,
      localShowModal,
      handleMenuItemSelected,
      handlePriceRangeSelected,
      handleBathBedSelected,
      toggleModal,
      closeViewModal,
      handleMorePropertyFilters,
      filterProperties,
    };
  },
};
</script>
